import { PageRef } from 'providers/page-ref';
import { FitnessPlan } from '@cf-shared/data-model/fitness-plan';
import { Gender } from '@cf-shared/enums';

export type EditNutritionPlanPageParams = {
  returnCallback?: string;
  local?: {
    isFlexible: boolean;
    gender: Gender;
    /** current values (from solver with overrides applied) */
    dailyIntake: number;
    protein: number;
    carbs: number;
    fat: number;
    fiber: number;
    /** solver-computed recommended values (without user overrides) */
    recommendedDailyIntake: number;
    recommendedProtein: number;
    recommendedCarbs: number;
    recommendedFat: number;
    recommendedFiber: number;
    /** meals per day — needed to round carbs/fat per-meal to match solver */
    mealsDaily: number;
    /** existing override state (for ratio slider and auto-adjust in fixed mode) */
    carbFatRatio?: number;
    autoAdjust?: boolean;
    returnContext?: unknown;
  };
};

export interface EditNutritionPlanPageResult {
  dailyIntake: number;
  overrideMacros: FitnessPlan['overrideMacros'];
}

export const IEditNutritionPlanPage: PageRef<EditNutritionPlanPageParams, EditNutritionPlanPageResult | undefined> = {
  pageName: 'EditNutritionPlanPage',
} as PageRef<EditNutritionPlanPageParams, EditNutritionPlanPageResult | undefined>;
